import React from "react";
import "./HousekeepingHero.css";
import Navbar from "../../Header/Navbar";

const FrontOfficeHero = () => {
  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="hk-hero">
        <div className="hk-container">
          
          {/* Main Title */}
          <h1 className="hk-title">Front Office & Helpdesk Management</h1>

          {/* Breadcrumb with links */}
          <p className="hk-subtitle">
            <a href="/" className="hk-link">Home</a> -{" "}
            <a href="/services" className="hk-link">Our Services</a> -{" "}
            <span>Front Office & Helpdesk Management</span>
          </p>

        </div>
      </section>

      {/* About Tag BELOW HERO */}
      <div className="hk-tag-wrapper">
        <div className="hk-tag">About This Service</div>
      </div>
     
    </>
  );
};

export default FrontOfficeHero;
